import { Trans } from '@lingui/macro'
import { Divider, Grid, Typography } from '@mui/material'
import { CurrencyFormated } from 'app/views/common/Formats'

export const FormOtherGrantsPrint = ({ title, value = [] }) => {
  if (value.length === 0) {
    return (
      <>
        <div className='form-read-only-header'>{title}</div>
        <Typography className='form-read-only-text'>
          <Trans>This list is empty!</Trans>
        </Typography>
      </>

    )
  }

  return (
    <div style={{ width: '100%' }}>
      <div className='form-read-only-header'>{title}</div>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={5} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Name</Trans>
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Value</Trans>
          </Typography>
        </Grid>
        <Grid item xs={3} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Grants: State</Trans>
          </Typography>
        </Grid>
      </Grid>
      {value.map((grant, index) => {
        return (
          <span key={index}>
            <Divider />
            <Grid container key={index} style={{ width: '100%' }}>
              <Grid item xs={5} style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>{grant.name}</Typography>
              </Grid>
              <Grid item xs={4} style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>
                  <CurrencyFormated value={grant.value} />
                </Typography>
              </Grid>
              <Grid item xs={3} style={{ padding: 4 }}>
                <Typography className='form-read-only-text'>
                  <Trans id={grant.state} />
                </Typography>
              </Grid>
            </Grid>
          </span>
        )
      })}
    </div>
  )
}
